import inquiryopinion from '@/view/inquiry-opinion';

const opinion = {
    install:function (Vue) {
        Vue.component('opinion',inquiryopinion)
    }
}
export default opinion;